import React from 'react';
import { formatDateTime } from 'utils/datetime';

const UserTable = ({ users, currentUserId, currentUserRole, onDelete }) => {
  // Only Owner / Admin can delete other users.
  const canManageOthers = currentUserRole === 'Owner' || currentUserRole === 'Admin';
  if (!users.length) {
    return (
      <div className="gh-box-body text-center text-muted-gh">
        <i className="bi bi-people fs-3 d-block mb-2" aria-hidden="true"></i>
        No users
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <table className="table align-middle">
        <thead>
          <tr>
            <th scope="col">Username</th>
            <th scope="col">Email</th>
            <th scope="col">Role</th>
            <th scope="col">Registered</th>
            {canManageOthers && <th scope="col" className="text-nowrap" style={{ width: '1%' }}>Actions</th>}
          </tr>
        </thead>
        <tbody>
          {users.map((user) => {
            const isSelf = user.id === currentUserId;
            const isOwner = user.role === 'Owner';
            const deleteDisabled = isSelf || isOwner;
            const deleteTitle = isOwner
              ? 'Owner users cannot be deleted'
              : isSelf
                ? 'You cannot delete yourself'
                : undefined;
            return (
              <tr key={user.id}>
                <td className="fw-semibold">
                  <i className="bi bi-person-circle me-2 text-muted-gh" aria-hidden="true"></i>
                  {user.username}
                </td>
                <td className="text-muted-gh">{user.email}</td>
                <td>
                  <span className="gh-label gh-label-pending">{user.role}</span>
                </td>
                <td className="text-muted-gh">{formatDateTime(user.createdAt)}</td>
                {canManageOthers && (
                  <td>
                    <button
                      type="button"
                      className="btn btn-sm btn-gh-danger text-nowrap"
                      disabled={deleteDisabled}
                      title={deleteTitle}
                      onClick={() => onDelete(user)}
                    >
                      <i className="bi bi-trash me-1" aria-hidden="true"></i>
                      Delete
                    </button>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default UserTable;
